var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0290b6b0f30ac5f150bf28fc2730269000785625"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fluffy-insurance-react@fluffy"]={id:"0290b6b0f30ac5f150bf28fc2730269000785625"};
      